import React from 'react';

import './Star.css';

interface CustomCSSProperties extends React.CSSProperties {
  '--rotation'?: string;
  '--animationDelay'?: string;
  '--transform'?: string;
}

interface StarProps {
  rotation: number;
  isActive: boolean;
  animationDelay: number;
  starId: number;
  style?: CustomCSSProperties;
}

export const Star: React.FC<StarProps> = ({
  rotation,
  isActive,
  animationDelay,
  style,
  starId,
}) => {
  const gradientId = `gradient-${rotation}-${animationDelay}`;
  const outlineGradientId = `outlineGradient-${starId}`;
  const containerStyle: CustomCSSProperties = {
    ...style,
    '--rotation': `${rotation}deg`,
    '--animationDelay': `${animationDelay}s`,
    '--transform': `scale(0.0) rotateY(0deg) rotate(${rotation}deg)`,
  };

  return (
    <div className="StarContainer" style={containerStyle}>
      <svg viewBox="0 0 336 321" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" className="StarGradient" />
            <stop offset="33%" className="StarGradient" />
            <stop offset="63%" className="StarGradient2" />
            <stop offset="88%" className="StarGradient3" />
            <stop offset="100%" className="StarGradient3" />
          </linearGradient>
          <linearGradient
            id={outlineGradientId}
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#d5bb43" stopOpacity="1" />
            <stop offset="53.13%" stopColor="#ffeb8e" stopOpacity="1" />
            <stop offset="100%" stopColor="#d5bb43" stopOpacity="1" />
          </linearGradient>
        </defs>
        <path
          d="M326.75 128.75L217.08 112.81L168.03 13.4297L118.99 112.81L9.31006 128.75L88.6701 206.1L69.9401 315.33L168.03 263.76L266.13 315.33L247.39 206.1L326.75 128.75Z"
          className="StarBackground"
        />
        <path
          d="M168.03 36.8799L208.24 118.34L298.13 131.4L233.08 194.81L248.44 284.34L168.03 242.07L87.6299 284.34L102.98 194.81L37.9399 131.4L127.83 118.34L168.03 36.8799Z"
          className={isActive ? `Star-${starId} Active` : `Star-${starId}`}
          fill={isActive ? `url(#${gradientId})` : '#383838'}
        />
        <path
          d="M88.6701 200.62L9.31006 123.27L118.99 107.33L168.03 7.94971L217.08 107.33L326.75 123.27L247.39 200.62L266.13 309.85L168.03 258.28L69.9401 309.85L88.6701 200.62Z"
          className="StarOutline"
        />
      </svg>
    </div>
  );
};

Star.defaultProps = {
  style: {},
};
